import { Box } from "@mui/material";

type CornerDotProps = {
    position: 'nw' | 'ne' | 'sw' | 'se';
  };
  
  export function CornerDot({ position }: CornerDotProps) {
    const positions = {
      nw: { top: '-8px', left: '-8px', cursor: 'nw-resize' },
      ne: { top: '-8px', right: '-8px', cursor: 'ne-resize' },
      sw: { bottom: '-8px', left: '-8px', cursor: 'sw-resize' },
      se: { bottom: '-8px', right: '-8px', cursor: 'se-resize' },
    };
  
    return (
      <Box
        sx={{
          position: 'absolute',
          width: '16px',
          height: '16px',
          backgroundColor: 'primary.main',
          borderRadius: '50%',
          pointerEvents: 'auto',
          ...positions[position],
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: '8px',
            height: '8px',
            backgroundColor: 'white',
            borderRadius: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        />
      </Box>
    );
  }